import React, {useContext, useEffect, useState} from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Divider,
  Checkbox,
  Steps,
  Form,
  Input,
  Select,
  DatePicker,
} from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { campaignPhase } from "../../constants/campaign.constant";
import { getCampaignNameFromPhase } from "./utils";
import {getFormattedDate, noAccess} from "../../utils/common";
import { createCampaign, fetchCampaignByUUID, updateCampaign } from "../../services/campaign.service";
import dayjs from "dayjs";
import { showSuccessMessage } from "../../utils/notification.util";
import {GlobalContext} from "../../context/GlobalContext";
import {roleValues} from "../../config/roles";

const { Step } = Steps;
const { Option } = Select;

export default function CampaignForm() {
  const { setBreadCrumb, user } = useContext(GlobalContext);
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({ state: '', district: '', phase: '', description: '', startDate: '', endDate: '' });
  const [form] = Form.useForm();
  const geoStates = JSON.parse(localStorage.getItem('GEO_STATES')) || [];
  const [geoDistricts, setGeoDistricts] = useState([]);
  useEffect(() => {
    if(user?.role !== roleValues.admin) {
        noAccess();
    }
    if (uuid) {
      fetchCampaignByUUID(uuid)
      .then((response) => {
        const data = {
          ...response.data,
          startDate: dayjs(response.data.startDate, 'YYYY-MM-DD'),
          endDate:dayjs(response.data.endDate, 'YYYY-MM-DD'),
        }
        form.setFieldsValue(data);
        console.log('location Data:', data);
      })
      .catch((error) => {console.log(error)});
    }

      setBreadCrumb([
          {
              title: 'Survivor Identification',
              link: '/location',
          },
      ]);
  }, []);
  const changeState = (value) => {
    form.setFieldsValue({ district: '' });
    const districts = geoStates.find((state) => state?.details.id === value).districts;
    setGeoDistricts(districts);
  };
  useEffect(() => {
    const value = form.getFieldValue('state');
    if (value) {
      const districts = geoStates.find((state) => state?.details.id === value).districts;
      setGeoDistricts(districts);
    }
  }, [geoStates]);
  const steps = [
    {
      title: "Location Details",
      content: (
        <>
        <Row gutter={[24, 0]} >
            <Col xs={24} xl={12}>
              <Form.Item
                  name="state"
                  label="State"
                  rules={[
                    {
                      required: true,
                      message: "Please select an option!",
                    },
                  ]}
                >
                <Select onChange={changeState}>
                  {geoStates.length > 0 && geoStates.map((item, index) => {
                    return (
                      <Option value={item?.details.id} key={index}>
                        {item?.details.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} xl={12}>
              <Form.Item
                name="district"
                label="District"
                rules={[
                  {
                    required: true,
                    message: "Please select an option!",
                  },
                ]}
              >
                <Select>
                  {geoDistricts.length > 0 && geoDistricts.map((item, index) => {
                    return (
                      <Option value={item.district} key={index}>
                        {item.district}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[24, 0]}>
            <Col xs={24} xl={12}>
              <Form.Item
                name="phase"
                label="Phase"
                rules={[
                  {
                    required: true,
                    message: "Please select an option!",
                  },
                ]}
              >
                <Select>
                  {campaignPhase.map((phase, index) => {
                    return (
                      <Option value={phase.key} key={index}>
                        {phase.value}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[24, 0]}>
            <Col xs={24} xl={24}>
              <Form.Item
                name="description"
                label="Description"
                rules={[{ required: true, message: "Please specify" }]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Enter your answers here"
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
    {
      title: "Additional Information",
      content: (
        <>
          <Row gutter={[24, 0]}>
            <Col xs={24} xl={6}>
              <Form.Item
                name="startDate"
                label="Start Date"
                rules={[
                  {
                    required: true,
                    message: "Please select the start date!",
                  },
                ]}
              >
                <DatePicker format="YYYY-MM-DD" />
              </Form.Item>
              <Form.Item
                name="endDate"
                label="End Date"
                rules={[
                  {
                    required: true,
                    message: "Please select the end date!",
                  },
                ]}
              >
                <DatePicker format="YYYY-MM-DD" />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
    {
      title: "Review",
      content: (
        <>
          <Divider>Location Details</Divider>
          <p>
            <strong>State:</strong> {geoStates.find(x => x.province === formData.state)?.details.name}
          </p>
          <p>
            <strong>District:</strong> {formData.district}
          </p>
          <p>
            <strong>Phase:</strong> {getCampaignNameFromPhase(formData.phase)}
          </p>
          <p>
            <strong>Start Date:</strong> {getFormattedDate(formData.startDate.toString(), 'MMMM DD, YYYY')}
          </p>
          <p>
          <strong>End Date:</strong> {getFormattedDate(formData.endDate.toString(), 'MMMM DD, YYYY')}
          </p>
          <p>
            <strong>Description:</strong>
          </p>
          <p>{formData.description}</p>
        </>
      ),
    },
  ];

  const next = () => {
    form.validateFields().then(values => {
      setFormData(prevData => ({ ...prevData, ...values }));
      setCurrentStep(currentStep + 1);
    }).catch((error) => {
      console.error('Validation failed:', error);
    });;
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  const onFinish = () => {
    console.log('Form Data:', formData);
    if (uuid) {
      updateCampaign(uuid, formData)
      .then((response) => {
        showSuccessMessage(`${formData.district} updated successfully!`);
        navigate(`/location/detail/${uuid}`);
      })
      .catch((error) => {console.log(error)});
    } else {
      createCampaign(formData)
      .then((response) => {
        showSuccessMessage(`${formData.district} created successfully!`);
        navigate(`/location/detail/${response.data.uuid}`);
      })
      .catch((error) => {console.log(error)});
    }
  };

  return (
    <>
      <Row gutter={[24, 0]}>
      <Col xs={24} xl={24}>
      <Steps current={currentStep}>
        {steps.map(item => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      </Col>
      </Row>
      <Row gutter={[24, 0]} style={{marginTop: '20px'}}>
      <Col xs={24} xl={24}>
          <Card
                  bordered={true}
                  className="criclebox tablespace mb-24"
                  style={{padding: '20px'}}
                >
              <Form form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    key={JSON.stringify(formData)}
                    initialValues={formData}>
                      <div style={{padding: '24px'}}>
                          {steps[currentStep].content}
                      </div>
                      <div style={{marginTop: 24}}>
                          {currentStep > 0 && (
                              <Button style={{marginRight: 8}} onClick={prev}>
                                  Previous
                              </Button>
                          )}
                          {currentStep < steps.length - 1 && (
                              <Button type="primary" onClick={next}>
                                  Next
                              </Button>
                          )}
                          {currentStep === steps.length - 1 && (
                              <Button type="primary" htmlType="submit">
                                  Submit
                              </Button>
                          )}
                      </div>
              </Form>
          </Card>
      </Col>
      </Row>
    </>
  );
}
